import Link from 'widget/components/Link';

export default function ExternalLink<Props extends Record<string, unknown>>({ ...props }: Props) {
  return <Link rel="noopener noreferrer" target="_blank" {...props} />;
}
